import React from "react";
import UserContextProvider from "../contexts/UserContextProvider";
import UserProfileEditComponent from "../components/UpdateUserProfile";

function UserProfileEdit() {
  return (
    <UserContextProvider>
      <UserProfileEditComponent />
    </UserContextProvider>
  );
}

export default UserProfileEdit;
